import { styled, Theme, CSSObject } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

export const sidebarWidth = {
  open: '342px',
  closed: '82px',
};

export const openedMixin = (theme: Theme): CSSObject => ({
  width: sidebarWidth.open,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

export const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: sidebarWidth.closed,
  [theme.breakpoints.up('sm')]: {
    width: sidebarWidth.closed,
  },
});

export const DrawerHeader = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: theme.spacing(0, 4),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));


export const SidebarStyled = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: sidebarWidth.open,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    svg: {
      stroke: theme.palette.grey[700],
      color: theme.palette.grey[700],
    },
    span: {
      color: theme.palette.grey[700],
      fontWeight: '500',
      fontSize: theme.typography.tmd.fontSize,
    },
    '.MuiDrawer-paper': {
      padding: '32px 16px 24px 16px',
      backgroundColor: theme.palette.primary.background,
    },
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

export const ListItemButtonStyled = styled(ListItemButton)<any>(({ open }) => ({
  minHeight: 48,
  justifyContent: open ? 'initial' : 'center',
  padding: '0px 16px',
  borderRadius: '6px',
  marginBottom: '8px',
}));

export const ListItemIconStyled = styled(ListItemIcon)<any>(({ open }) => ({
  minWidth: 0,
  marginRight: open ? 8 : '0px',
  justifyContent: 'center',
}));

export const ListItemTextStyled = styled(ListItemText)<any>(({ open }) => ({
  display: open ? 'inline-block' : 'none',
}));
